import { Input } from "@/components/ui/input";
import {
	InputSideLabel,
	InputSideLabelPopover,
} from "@/components/ui/InputSideLabel";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/components/ui/popover";
import { TriangleAlertIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { t } from "i18next";
import type { ParameterInputProps } from "./types";
import { getInputClass } from "./utils";

export const AnnualSalaryInput = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"annual-salary">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					const value = e.target.value;
					parameter.value = value;
					parameter.error = null;

					if (value.length < 1) {
						parameter.error = t(
							"admin.insurances.parameters.error.annual-salary-required"
						);
					}
					if (value.length > 5) {
						parameter.error = t(
							"admin.insurances.parameters.error.annual-salary-max"
						);
					}
					if (Number(value) < 0) {
						parameter.error = t(
							"admin.insurances.parameters.error.annual-salary-positive"
						);
					}
					if (isNaN(Number(value))) {
						parameter.error = t(
							"admin.insurances.parameters.error.annual-salary-number"
						);
					}
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-24 pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						{parameter.error ? (
							<TriangleAlertIcon className="stroke-destructive" />
						) : (
							"x"
						)}
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t("admin.insurances.parameters.type-to-name.annual-salary")}
						error={parameter.error}
						content={t(
							"admin.insurances.parameters.content.annual-salary-multiple"
						)}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};

export const AnnualSalaryAboveXGInput = ({
	store,
	insurance,
	parameter,
}: ParameterInputProps<"annual-salary-above-x-g">) => {
	return (
		<div className="relative flex">
			<Input
				type="number"
				onWheel={(e) => (e.target as HTMLInputElement).blur()}
				value={parameter.value}
				onChange={(e) => {
					parameter.value = e.target.value;
					store.editParameter(insurance, parameter);
				}}
				className={cn("w-24 pr-12", getInputClass(parameter))}
			/>
			<Popover>
				<PopoverTrigger asChild>
					<InputSideLabel
						className={cn(
							"cursor-pointer",
							parameter.isAltered && "border-orange-400"
						)}
					>
						AB
					</InputSideLabel>
				</PopoverTrigger>
				<PopoverContent>
					<InputSideLabelPopover
						title={t(
							"admin.insurances.parameters.type-to-name.annual-salary-above-x-g"
						)}
						error={parameter.error}
						content={t(
							"admin.insurances.parameters.content.annual-salary-above-x-g"
						)}
						isAltered={parameter.isAltered}
						resetParam={() => store.resetParameter(insurance, parameter)}
					/>
				</PopoverContent>
			</Popover>
		</div>
	);
};
